import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
  error?: string;
}

export function Input({ label, hint, error, id, style, ...rest }: InputProps) {
  const inputId = id ?? `input-${label}`;
  return (
    <div style={{ marginBottom: '16px' }}>
      <label
        htmlFor={inputId}
        style={{
          display: 'block',
          fontSize: '11px',
          color: '#d1d5db',
          marginBottom: '6px',
        }}
      >
        {label}
      </label>
      <input
        id={inputId}
        {...rest}
        style={{
          width: '100%',
          background: 'var(--color-input)',
          border: error ? '0.5px solid rgba(239, 68, 68, 0.6)' : 'var(--border-strong)',
          borderRadius: 'var(--radius-md)',
          padding: '9px 11px',
          color: 'var(--color-text-primary)',
          fontSize: '12px',
          outline: 'none',
          ...style,
        }}
      />
      {(error ?? hint) && (
        <p
          style={{
            margin: '4px 0 0',
            fontSize: '10px',
            color: error ? 'var(--color-error-text)' : 'var(--color-text-tertiary)',
          }}
        >
          {error ?? hint}
        </p>
      )}
    </div>
  );
}
